import React, {useEffect, useRef, useState} from "react";
import {withTranslation} from "react-i18next";
import classNames from "classnames";
import "./index.scss";
import {useOnClickOutside} from "../../../services/hooks";
import {DateRangePicker as DateRangePickerPlugin} from 'react-dates';
import 'react-dates/initialize';
import moment from "moment";
import 'react-dates/lib/css/_datepicker.css';
import uuid from "draft-js/lib/uuid.js";
import IconButton from "../IconButton/IconButton.jsx";
import 'moment/locale/ar';
import 'moment/locale/de';
import 'moment/locale/el';
import 'moment/locale/he';
import 'moment/locale/es';
import 'moment/locale/pl';
import 'moment/locale/ru';

const DateRangePicker = ({
  t,
  defaultStartDate,
  defaultEndDate,
  isOpen,
  onClose,
  systemLanguage,
    disableDateBefore,
}) => {
  const targetRef = useRef();
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [focusedInput, setFocusedInput] = useState('startDate');
  const [initialVisibleMonth, setInitialVisibleMonth] = useState(
        defaultStartDate ? moment(defaultStartDate).startOf("month") : moment()
    );

  useEffect(() => {
    moment.locale(systemLanguage);
  }, [systemLanguage]);

  useEffect(() => {
    if(defaultStartDate){
      setStartDate(moment(defaultStartDate).add(1, 'day'));
        setFocusedInput('endDate')
    }

    if(defaultEndDate){
      setEndDate(moment(defaultEndDate).add(1, 'day'));
    }
  }, [defaultStartDate, defaultEndDate]);

  useEffect(() => {
      if(disableDateBefore && disableDateBefore.endDate){
          setInitialVisibleMonth(moment(disableDateBefore.endDate).add(1, 'day').startOf("month"));
      }
  }, [disableDateBefore, disableDateBefore.endDate]);


  const handleOnClose = value => {
    return onClose(startDate && setEndDate ? {StartDate: startDate.toISOString(), EndDate: endDate.toISOString()} : null);
  };

  const handleOnChange = ({ startDate, endDate }) => {
    setStartDate(startDate);
    setEndDate(endDate);
  }

  const RenderCustomPrevNav = (onClick, ariaLabel) => (
      <div
          className={classNames("dateRangePickerLeft")}
          onClick={() => onClick}
      >
          <IconButton isIcon iconName={"arrowCalendar"}/>
      </div>
  );

    const RenderCustomNextNav = (onClick, ariaLabel) => (<>
            <div
                className={classNames("dateRangePickerRight")}
                onClick={() => onClick}
            >
                <IconButton isIcon iconName={"arrowCalendar"}/>
            </div>
        </>
    );

    const RenderCustomCalendarDay = (props) => {
        const { day } = props;
        return (<>
            <span className="custom-day">
        {day.format("D")}
      </span>
            </>
        );
    }

    const isOutsideRange = (day) => {
        if(disableDateBefore && disableDateBefore.endDate){
            const blockBeforeDate = moment(disableDateBefore.endDate).add(1, 'day');

            return day.isBefore(blockBeforeDate, 'day');
        }
        return false;
    };

    useOnClickOutside(targetRef, () => {
        return onClose(null);
    });
    const startDateId = `date_${uuid()}_id`;
    const endDateId = `date_${uuid()}_id`;
    return (
        <div className={classNames("dateRangePickerContainer")} ref={targetRef}>
        <div className="range-date-picker">
          <DateRangePickerPlugin
              startDate={startDate}
              endDate={endDate}
              onDatesChange={handleOnChange}
              focusedInput={focusedInput}
              onFocusChange={setFocusedInput}
              numberOfMonths={2}
              keepOpenOnDateSelect={isOpen}
              isOutsideRange={isOutsideRange}
              displayFormat="DD/MM/YYYY"
              startDateId={startDateId}
              endDateId={endDateId}
              navPrev={<RenderCustomPrevNav />}
              navNext={<RenderCustomNextNav />}
              hideKeyboardShortcutsPanel={true}
              initialVisibleMonth={() => initialVisibleMonth}
              renderDayContents={(day) => <RenderCustomCalendarDay day={day} />}
          />
        </div>
        <button onClick={() => handleOnClose("value")} className={classNames("btn", "confirm", "dateRangePickerButton")}>
          {t("basic.CHOOSE")}
        </button>
      </div>
  );
};

export default withTranslation()(DateRangePicker);
